import { Box, Popover } from "@mui/material";

import { BorderSide } from "~/features/andon/andon.types";

import CellBorderControls from "./CellBorderControls";

type AndonMultiCellBorderPopoverProps = {
  open: boolean;
  anchorPosition: { left: number; top: number } | undefined;
  cellBorderSides: BorderSide[];
  cellBorderColor: string;
  onClose: (
    event?: object | React.SyntheticEvent | Event | null,
    reason?: string
  ) => void;
  onSetCellBorder: (sides: BorderSide[], color: string) => void;
};

export default function AndonMultiCellBorderPopover({
  open,
  anchorPosition,
  cellBorderSides,
  cellBorderColor,
  onClose,
  onSetCellBorder
}: AndonMultiCellBorderPopoverProps) {
  return (
    <Popover
      open={open}
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    >
      <Box sx={{ width: 320, py: 1 }}>
        <CellBorderControls
          cellBorderSides={cellBorderSides}
          cellBorderColor={cellBorderColor}
          onSetCellBorder={onSetCellBorder}
        />
      </Box>
    </Popover>
  );
}
